import React from "react";
import "./nav.css";
import { AiOutlineHome } from "react-icons/ai";
import { AiOutlineUser } from "react-icons/ai";
import { GiNotebook } from "react-icons/gi";
import { MdMedicalServices } from "react-icons/md";
import { RiContactsFill } from "react-icons/ri";
import { AiFillProject } from "react-icons/ai";
import { BsTag } from "react-icons/bs";
import { useState } from "react";
import { Link } from "react-router-dom";

const Nav = () => {
  const [activeNav, setActiveNav] = useState("#header");

  return (
    <nav>
      <Link
        to="/"
        onClick={() => setActiveNav("#header")}
        className={activeNav === "#header" ? "active" : ""}
      >
        <AiOutlineHome />
      </Link>
      <Link
        to="/about"
        onClick={() => setActiveNav("#about")}
        className={activeNav === "#about" ? "active" : ""}
      >
        <AiOutlineUser />
      </Link>
      <Link
        to="/experience"
        onClick={() => setActiveNav("#experience")}
        className={activeNav === "#experience" ? "active" : ""}
      >
        <GiNotebook />
      </Link>

      <Link
        to="/services"
        onClick={() => setActiveNav("#services")}
        className={activeNav === "#services" ? "active" : ""}
      >
        <MdMedicalServices />
      </Link>

      <Link
        to="/pricing"
        onClick={() => setActiveNav("#pricing")}
        className={activeNav === "#pricing" ? "active" : ""}
      >
        <BsTag />
      </Link>

      <Link
        to="/portfolio"
        onClick={() => setActiveNav("#portfolio")}
        className={activeNav === "#portfolio" ? "active" : ""}
      >
        <AiFillProject />
      </Link>

      <Link
        to="/contact"
        onClick={() => setActiveNav("#contact")}
        className={activeNav === "#contact" ? "active" : ""}
      >
        <RiContactsFill />
      </Link>
    </nav>
  );
};

export default Nav;
